import { SET_ONBOARDING_STEP, SET_ONBOARDING_TYPE, SET_ONBOARDING_PURPOSE, SET_ONBOARDING_EXPERIENCE, SET_ONBOARDING_GOAL, SET_ONBOARDING_WAY_TO_REACH, SET_ONBOARDING_SECOND_BRANCH, SET_ONBOARDING_SELECTED_SKILL, SET_ONBOARDING_RELATED_SUBJECTS, SET_ONBOARDING_IS_LOADING, SET_ONBOARDING_SUCCESS_UUID, SET_ONBOARDING_X_PRODUCT, SET_ONBOARDING_MAX_PRODUCT, SET_ONBOARDING_IS_PREMIUM, SET_ONBOARDING_RELATED_PERSONALISED_SKILLS, SET_ONBOARDING_PERSONALISED_SKILLS_LOADING, SET_COURSE_UNLOCK_POLLING, SET_COURSE_UNLOCK_STATUS } from "../actions/types";

const initialState = {
  step : 1,
  maxStep : 1,
  type : "",
  purpose : "",
  experience : "",
  goal : "",
  wayToReach : "",
  secondBranch : false,
  selectedSkill : {},
  relatedSubjects : [],
  relatedPersonalisedSkills : [],
  isPersonalisedSkillsLoading : false,
  isLoading : false,
  successUuid : "",
  xProduct : {},
  maxProduct : {},
  isPremium : false,
  isCourseUnlockPolling : false,
  courseUnlockStatus : null
};
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_ONBOARDING_STEP:
      return {
        ...state,
        step: action.payload,
        maxStep: Math.max(state.maxStep, action.payload),
      };
    case SET_ONBOARDING_TYPE:
      return {
        ...state,
        type: action.payload,
      };
    case SET_ONBOARDING_PURPOSE:
      return {
        ...state,
        purpose: action.payload,
      };
    case SET_ONBOARDING_EXPERIENCE:
      return {
        ...state,
        experience: action.payload,
      };
    case SET_ONBOARDING_GOAL:
      return {
        ...state,
        goal: action.payload,
      };
    case SET_ONBOARDING_WAY_TO_REACH:
      return {
        ...state,
        wayToReach: action.payload,
      };
    case SET_ONBOARDING_SECOND_BRANCH:
      return {
        ...state,
        secondBranch: action.payload,
      };
    case SET_ONBOARDING_SELECTED_SKILL:
      return {
        ...state,
        selectedSkill: action.payload,
      };
    case SET_ONBOARDING_RELATED_SUBJECTS:
      return {
        ...state,
        relatedSubjects: action.payload,
      };
    case SET_ONBOARDING_RELATED_PERSONALISED_SKILLS:
      return {
        ...state,
        relatedPersonalisedSkills: action.payload,
      };
    case SET_ONBOARDING_PERSONALISED_SKILLS_LOADING:
      return {
        ...state,
        isPersonalisedSkillsLoading: action.payload,
      };
    case SET_ONBOARDING_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_ONBOARDING_SUCCESS_UUID:
      return {
        ...state,
        successUuid: action.payload,
      };
    case SET_ONBOARDING_X_PRODUCT:
      return {
        ...state,
        xProduct: action.payload,
      };
    case SET_ONBOARDING_MAX_PRODUCT:
      return {
        ...state,
        maxProduct: action.payload,
      };
    case SET_ONBOARDING_IS_PREMIUM:
      return {
        ...state,
        isPremium: action.payload,
      };
    case SET_COURSE_UNLOCK_POLLING:
      return {
        ...state,
        isCourseUnlockPolling: action.payload,
      };
    case SET_COURSE_UNLOCK_STATUS:
      return {
        ...state,
        courseUnlockStatus: action.payload,
      };
    default:
      return state;
  }
}
